<template>
  <amplify-authenticator v-bind:authConfig="authConfig"></amplify-authenticator>
</template>

<script>
import { Auth, Hub } from 'aws-amplify';

export default {
    name: 'login',
    data() {
        return {
            authConfig: {   
          signUpConfig: {
            header: 'Create Account',
            signUpFields: [
              {
                label: 'Phone Number',
                key: 'phone_number',
                displayOrder: 4,
                required: false
              }
            ]
          }
        }
        }
    }
}
</script>

